/**
 * Internal dependencies
 */
import vd from 'lib/vd';
import recieveReports from './recieve-reports';
import * as actions from 'state/action-types';

export default (reportId = null, report) => (dispatch) => {
	const isNew = !reportId;

	if (isNew) {
		return vd
			.widget()
			.add(report)
			.then((report) => {
				dispatch(recieveReports([report]));
				dispatch({ type: actions.SAVE_REPORT_SUCCESS, payload: { report, isNew } });
			});
	}

	return vd
		.widget(reportId)
		.update(report)
		.then((report) => {
			dispatch(recieveReports([report]));
			dispatch({ type: actions.SAVE_REPORT_SUCCESS, payload: { report } });
		});
};
